var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0H5ZM0 5C0 4.44772 0.447715 4 1 4H3H13H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H13.905L13.2796 12.2539L13.2796 12.254C13.2318 12.7322 13.1903 13.1471 13.129 13.4885C13.064 13.8506 12.9648 14.2067 12.7616 14.545C12.4563 15.0531 12.0074 15.4594 11.4715 15.7125C11.1147 15.8811 10.7504 15.9443 10.3836 15.973C10.0379 16 9.62092 16 9.14033 16H9.14031H9.14029H6.85972H6.8597H6.85968C6.37909 16 5.96214 16 5.61636 15.973C5.24957 15.9443 4.88533 15.8811 4.52853 15.7125C3.99259 15.4594 3.54366 15.0531 3.23841 14.545C3.03518 14.2067 2.93602 13.8506 2.871 13.4885C2.80969 13.1471 2.76822 12.7322 2.72041 12.254L2.72041 12.254L2.09502 6H1C0.447715 6 0 5.55228 0 5ZM4.10499 6H11.895L11.2931 12.0189C11.2407 12.5435 11.2063 12.8798 11.1605 13.135C11.1169 13.378 11.075 13.4687 11.0472 13.515C10.9455 13.6844 10.7958 13.8198 10.6172 13.9042C10.5683 13.9273 10.474 13.9598 10.2278 13.9791C9.9693 13.9993 9.63122 14 9.10404 14H6.89596C6.36879 14 6.03071 13.9993 5.77221 13.9791C5.52604 13.9598 5.43168 13.9273 5.38283 13.9042C5.20418 13.8198 5.05454 13.6844 4.95279 13.515C4.92496 13.4687 4.88315 13.378 4.83951 13.135C4.79368 12.8798 4.75934 12.5435 4.70688 12.0189L4.10499 6Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash-icon-white.06b560d2e4627115d64e128be1b2a1b2.svg";